import { Chip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Entity } from '../../../types';

export interface File extends Entity {
  name: string;
  type: string;
  hash: string;
  size: number;
}

interface PDFDownloadProps {
  pdf: File;
}

const PDFDownload = (props: PDFDownloadProps) => {
  const handleDownloadFile = () => {
    const url = `${process.env.REACT_APP_API_URL}/files/${props.pdf.id}`;
    window.open(url, '_blank', 'noreferrer,noopener');
  };

  const icon = (
    <FontAwesomeIcon
      icon={['fal', 'file-pdf']}
      style={{ width: 32, height: 32 }}
    />
  );

  return (
    <Chip
      label={props.pdf.name}
      color="primary"
      icon={icon}
      onClick={handleDownloadFile}
    />
  );
};

export default PDFDownload;
